const currencies = [
  { code: 'EUR', symbol: '€' },
  { code: 'MKD', symbol: 'MKD' }
]

const titles = ['MR', 'MRS', 'CHD', 'INF']
const round = (val) => { return Math.round(val * 100) / 100 }

export {
  currencies,
  titles,
  round
}
